<template>
  <a-modal
    :title="title"
    :visible="visible"
    :footer="null"
    @cancel="cancel"
    :maskClosable="false"
    :width="width"
  >
    <a-form :form="form" @submit="handleSubmit" labelAlign="right">
      <a-form-item label="仓库名称" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-input
          placeholder="请输入仓库名称"
          autocomplete="off"
          :disabled="disabled"
          v-decorator="['name',{validateTrigger: ['blur'],rules: [{ required: true, message: '请输入仓库名称!' }]}]"
        />
      </a-form-item>
      <a-form-item label="所属公司" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-tree-select
          v-decorator="['subcompanyid',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择所属公司!' }]}]"
          style="width: 100%"
          placeholder="所属公司"
          allow-clear
          show-search
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :treeData="companyList"
          treeNodeFilterProp="title"
          :replaceFields="{
            title: 'url',
            key: 'id',
            value: 'id'
          }"
          @change="changeCompany"
          :disabled="disabled"
        ></a-tree-select>
      </a-form-item>
      <a-form-item label="所属部门" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-spin :spinning="spinning">
          <a-tree-select
            v-decorator="['departmentid',{validateTrigger: ['change'],rules: [{ required: false, message: '请选择所属部门!' }]}]"
            style="width: 100%"
            placeholder="所属部门"
            allow-clear
            show-search
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :treeData="departmentList"
            treeNodeFilterProp="title"
            :replaceFields="{
              title: 'url',
              key: 'key',
              value: 'key'
            }"
            :disabled="disabled"
          ></a-tree-select>
        </a-spin>
      </a-form-item>
      <a-form-item label="仓库描述" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-textarea
          placeholder="请输入仓库描述"
          autocomplete="off"
          :disabled="disabled"
          v-decorator="['description',{validateTrigger: ['blur'],rules: [{ required: false, message: '请输入仓库描述!' }]}]"
        />
      </a-form-item>
      <a-form-item label="仓库管理员" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-select
          v-decorator="['warehouseCustodianList',{validateTrigger: ['change'],rules: [{ required: true, message: '请选择仓库管理员!' }]}]"
          :allowClear="true"
          mode="multiple"
          :disabled="disabled"
          :filter-option="false"
          @search="handleSelect"
          placeholder="仓库管理员">
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="(item, index) in warehouseManagerList" :key="index" :value="item.id">
            {{ item.lastname + '&ensp;|&ensp;' + item.subcompanyname + '&ensp;|&ensp;' + item.departmentname + '&ensp;|&ensp;' + item.jobTitleName }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <div class="footerBtn">
        <a-button type="primary" html-type="submit" style="margin-right: 10px" v-if="!disabled" :loading="loading">保存</a-button>
        <a-button @click="cancel">取消</a-button>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { getDeptTreeList, getTreeByRoleUsedeptList } from '@/api/assetLedger'
import { getPersonalInfo } from '@/api/baseInfo'
import { addWarehouses } from '@/api/warehouseManagement'

export default {
  name: 'DetailModel',
  props: ['subcompanyid'],
  data () {
    return {
      visible: false,
      type: '',
      title: '',
      width: 800,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 4 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      disabled: false,
      loading: false,
      fetching: false,
      spinning: false,
      comid: null,
      model: {},
      form: this.$form.createForm(this, { name: 'DetailModel' }),
      companyList: [],
      departmentList: [],
      warehouseManagerList: []
    }
  },
  created () {
    this.getCompanyList()
  },
  methods: {
    setType (type) {
      this.disabled = type === 'view'
      this.type = type
    },
    setTitle (title) {
      this.title = title
    },
    setModel (model) {
      const warehouseCustodianList = []
      model.warehouseCustodianList.map(item => {
        item.id = item.userId
        warehouseCustodianList.push(item.userId)
      })
      this.model = model
      this.$nextTick(() => {
        this.getDeptList(model.subcompanyid)
        this.comid = model.subcompanyid
        this.warehouseManagerList = model.warehouseCustodianList
        this.form.setFieldsValue({
          name: model.name,
          subcompanyid: model.subcompanyid,
          departmentid: model.departmentid ? model.departmentid + '_' + model.departmentname : undefined,
          description: model.description,
          warehouseCustodianList: warehouseCustodianList
        })
      })
    },
    open (flag) {
      this.visible = flag
      if (this.type === 'add' && (this.subcompanyid.data.type === 1 && (this.subcompanyid.data.children == null || this.subcompanyid.data.children[0].type === 2) || this.subcompanyid.data.type === 2)) {
        // 左侧树是公司
        this.comid = this.subcompanyid.data.type === 1 ? this.subcompanyid.data.id : this.subcompanyid.data.supsubcomid
        this.changeCompany(this.comid)
        this.$nextTick(() => {
          this.form.setFieldsValue({
            subcompanyid: this.comid
          })
        })
      }
    },
    // 重置children数组
    resetTheCompanyChildrenArray (children) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (item.children && item.children.length > 0) {
            item.disabled = true
            item.children = self.resetTheCompanyChildrenArray(item.children)
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 获取所属公司
    getCompanyList () {
      const data = {
        paging: false,
        subcompanyname: ''
      }
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          for (const item of res.data) {
            if (item.children && item.children.length > 0) {
              item.disabled = true
              item.children = this.resetTheCompanyChildrenArray(item.children)
            }
          }
          this.companyList = res.data
        } else {
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.$message.error(err.info.message)
        })
    },
    // 重置children数组
    resetTheDeptChildrenArray (children) {
      const arr = []
      const self = this
      if (children && children.length > 0) {
        for (let i = 0; i < children.length; i++) {
          const item = JSON.parse(JSON.stringify(children[i]))
          if (item.children && item.children.length) {
            if (item.type !== 2) {
              item.disabled = true
            }
            item.children = self.resetTheDeptChildrenArray(item.children)
          }
          arr.push(item)
        }
      }
      return arr
    },
    // 获取所属部门
    getDeptList (companyId) {
      const data = {
        paging: false,
        companyId: companyId
      }
      this.spinning = true
      getTreeByRoleUsedeptList(data).then(res => {
        if (res.status === 0) {
          for (const item of res.data) {
            if (item.type !== 2) {
              item.disabled = true
            }
            item.children = this.resetTheDeptChildrenArray(item.children)
          }
          this.departmentList = res.data
          this.spinning = false
        } else {
          this.spinning = false
        }
      }).catch(err => {
        this.spinning = false
        this.$message.error(err.info.message)
      })
    },
    // 使用防抖函数，并且设置延迟为500毫秒，传入方法为获取仓库管理员的方法，传入参数为下拉框的值
    handleSelect (value) {
      // 设置延迟时间为500毫秒
      const delay = 500
      // 使用定时器延迟执行防抖函数
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.warehouseManagerList = []
        const data = {
          comid: this.comid,
          lastname: value,
          paging: false
        }
        if (value) {
          this.getWarehouseManagerList(data)
        }
      }, delay)
    },
    // 获取仓库管理员
    getWarehouseManagerList (data) {
      if (!this.comid) {
        this.$message.error('请先选择所属公司')
        return
      }
      this.fetching = true
      getPersonalInfo(data).then(res => {
        if (res.status === 0) {
          this.fetching = false
          this.warehouseManagerList = res.data
        } else {
          this.fetching = false
          this.$message.error(res.info.message)
        }
      })
        .catch(err => {
          this.fetching = false
          this.$message.error(err.info.message)
        })
    },
    // 仓库管理员搜索
    filterOption (input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input) >= 0
      )
    },
    // 改变所属公司
    changeCompany (value) {
      this.departmentList = []
      this.warehouseManagerList = []
      if (value) {
        this.comid = value
        // 获取所属部门
        this.getDeptList(value)
        // 获取仓库管理员
        // this.getWarehouseManagerList(value)
      }
      this.form.setFieldsValue({
        departmentid: undefined,
        warehouseCustodianList: []
      })
    },
    // 保存
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields(async (err, value) => {
        if (!err) {
          const params = { ...value }
          if (params.departmentid) {
            params.departmentid = params.departmentid.substring(0, params.departmentid.indexOf('_'))
          }
          params.warehouseCustodianList = params.warehouseCustodianList.map(item => {
            return {
              userId: item
            }
          })
          if (this.type === 'edit') {
            params.id = this.model.id
          }
          this.loading = true
          addWarehouses(params).then(res => {
            if (res.status === 0) {
              this.loading = false
              this.$message.success(res.info.message)
              this.cancel()
              this.$emit('setSearchCondition')
            } else {
              this.loading = false
              this.$message.error(res.info.message)
            }
          })
            .catch(err => {
              this.loading = false
              this.$message.error(err.info.message)
            })
        }
      })
    },
    cancel () {
      this.departmentList = []
      this.warehouseManagerList = []
      this.comid = null
      this.form.resetFields()
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.footerBtn {
  display: flex;
  justify-content: flex-end;
}
</style>
